import { copyToClipboard, generateURL } from '../utils';
import { generateCommentPath } from './generate-content-object-path';
import type { GenerateCommentPathProperties } from './types';

const generateCommentContentObjectURL = (item: GenerateCommentPathProperties) => {
  const path = generateCommentPath(item);
  return generateURL(path);
};

export const copyCommentLinkToClipboard = async (item: GenerateCommentPathProperties) =>
  // eslint-disable-next-line @typescript-eslint/require-await -- Async is required by iOS interface, do not work without it
  copyToClipboard(async () => generateCommentContentObjectURL(item));
